import { widgetStore } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export type UseWidgetUIPhaseArg = {
  widgetId: string;
};

export const useWidgetUIPhase = ({ widgetId }: UseWidgetUIPhaseArg) => {
  return useSelectedFieldStore(
    widgetStore,
    () => widgetStore.get()[widgetId]?.widgetUIPhase
  );
};
